import React from "react";

import { StackProps, styled } from "@mui/material";

import { Row } from "@rui/Stack";

export const SearchFilterRow = styled((props: StackProps) => (
  <Row
    variant="left"
    sx={{
      py: { xxs: 1, sm: 2 },
      flexWrap: { xxs: "nowrap", sm: "wrap" },
      rowGap: "8px",
      columnGap: "8px",
      overflowX: { xxs: "scroll", sm: "hidden" },
    }}
    {...props}
  />
))({});
